import React, { useState } from "react";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";
export default function FAQquestions() {
  const { isDesktop } = useResponsiveFlags();
  const faqs = [
    {
      question: "iSort&trade; Fractions: How to prepare the input file?",
      answer: `The input file is a <strong>bulk</strong> expression matrix. The requirements are:<br/>
          <ol><li>
    The file must be in a <strong>tab-delimited text</strong> format, where the row names are the gene names and the column names are sample names.</li>
    <li>The <strong>sample names must be unique.</strong></li>
    <li><u>Ensembl IDs cannot be used for gene names.</u> Please convert them to <strong>HUGO-compliant gene names</strong>. If multiple Ensembl IDs are converted to a single gene name, sum the expression.</li>
    <li>For RNA-seq data, the expression values must be in <strong>TPM</strong> (transcripts per million), non-log, <strong>without any missing values.</strong></li>
    <li>For microarray data, iSort&trade; will apply quantile normalization.</li>
    <li>If your data set has significant batch differences (i.e, different library prep methods, different tissue types, etc.), separate the TPM file into multiple files, one for each batch.</li> </ol>
    `,
    },
    {
      question:
        "iSort&trade; Fractions: I see browser and desktop version. Which one shall I use?",
      answer: `<p><u>Browser version</u>: You upload the input file and download the results. No bioinformatics experience needed. Comes with easy-to-use GUI (graphical user interface).</p>
    <p><u>Desktop version</u>: This is a Docker-containerized command-line tool. If you do not want to upload your data, AND you are comfortable with command-line tool, desktop version is what you need.</p>
    Once you obtain a valid token (license key), you can run either versions.
    `,
    },
    {
      question:
        "iSort&trade; HiRes: Do I need to run iSort&trade; Fractions before running iSort&trade; HiRes?",
      answer: `Yes. iSort&trade; HiRes requires two input files.
    <ol><li> Bulk expression matrix you used to run iSort Fractions.</li>
    <li> Grouped cell proportion data created based on iSort Fractions output.
    </li></ol>
    See <a href="https://isort.cibermed.com/iSortHiRes_UserGuide_latest.pdf">iSort&trade; HiRes User Guide</a> for the instructions to prepare the grouped cell proportion data.`,
    },
    {
      question:
        "I have questions on the output. I also need some help on the analysis.",
      answer: `Send an email to <a href="mailto:support@cibermed.com">support@cibermed.com</a>. We will respond to your questions as soon as possible. As to downstream analysis methods / strategy, we may offer consultation service for a fee.`,
    },
    {
      question: `Can I use single-cell RNA-seq data, even though the instructions say that “bulk” expression data should be used? `,
      answer:
        "A bulk data is required. If you make a pseudo bulk data from scRNA-seq data, you can run iSort&trade;",
    },
  ];
  

  return (
    <>
      <section
        className="content-home"
        style={{
          padding: isDesktop ? "36px 36px 62px 36px" : "20px 20px 62px 20px",
        }}
      >
        <p className="screen-title ms-0">Frequently Asked Questions</p>
        {faqs.map((faq, index) => (
          <div className="border-0 border-bottom py-2">
            <button
              className="accordion-button collapsed no-focus-outline d-flex justify-content-between align-items-center p-0 pe-xl-3 m-0"
              style={{ margin: "8px 0" }}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={"#faq"+index}
              aria-expanded="false"
              aria-controls={"faq"+index}
            >
              <span className="form-label mb-0" style={{fontSize:"18px"}} dangerouslySetInnerHTML={{ __html: faq.question }} />
              <span className="icon-toggle ms-auto ps-3 home-card-title"></span>
            </button>
            <div
              id={"faq"+index}
              className="accordion-collapse collapse ps-3 pe-4 pe-xl-5"
              aria-labelledby={"collapse"+index}
            >
              <div className="mt-2 mb-2" dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </div>
          </div>
        ))}
      </section>
    </>
  );
}
